const DRIVE = 'DRIVE';
const FLY = 'FLY';
const STAY = 'STAY';
const DEFAULT_COLLISION_AVOIDANCE = {
    side: 'none',
    align: 'none',
    fallbackAxisSide: 'none'
};
const ITINERARY_BAR_BREAKPOINT_PX = 1024;
export { DEFAULT_COLLISION_AVOIDANCE, DRIVE, FLY, ITINERARY_BAR_BREAKPOINT_PX, STAY };
